import React from 'react';
import { useParams } from 'react-router';
import {
  Card,
  CardHeader,
  CardSection,
  Layout,
  SmallHeader,
  useApi,
} from '@axiom/ui';

import { CandidateUtil } from '../../utils/candidate-util';
import { UserApi } from '../../api/user-api';
import { CandidateApi } from '../../api/candidate-api';
import { PreferencesUtil } from '../../utils/preferences-util';
import { FeatureVisibilityUtil } from '../../utils/feature-visibility-util';

import { PreferencesNavigationItem } from './PreferencesNavigationItem';

export type PreferencesNavigationProps = {
  name?: string;
};

export const PreferencesNavigation = ({
  name = 'PREFERENCES_NAVIGATION',
}: PreferencesNavigationProps) => {
  const [{ data: user }] = useApi(UserApi.readUser());
  const { candidateId: urlCandidateId } = useParams();
  const candidateId = CandidateUtil.reconcileUserCandidateId(
    user,
    urlCandidateId
  );
  const [{ data: candidate }] = useApi(CandidateApi.readCandidate(candidateId));
  const {
    workStylePreferencesReviewedAt,
    profileVisibilityReviewedAt,
    programsPreferencesReviewedAt,
  } = candidate;

  return (
    <Card name={name}>
      <CardHeader>
        <SmallHeader>Preferences</SmallHeader>
      </CardHeader>
      <CardSection>
        <Layout direction="vertical" verticalGutter="16px">
          <PreferencesNavigationItem
            name="SIDE_NAV_COMMUNICATIONS"
            url="../communications"
          >
            Communications & Alerts
          </PreferencesNavigationItem>

          {!FeatureVisibilityUtil.shouldSeeLimitedFeatureSetBasedOnProfileStatus(
            candidate
          ) && (
            <>
              <PreferencesNavigationItem
                name="SIDE_NAV_FLEXIBILITY"
                url="../work-style"
                showBadge={PreferencesUtil.shouldPreferenceNeedReview(
                  workStylePreferencesReviewedAt
                )}
              >
                Flexibility
              </PreferencesNavigationItem>
              <PreferencesNavigationItem
                name="SIDE_NAV_PROFILE_VISIBILITY"
                url="../profile-visibility"
                showBadge={PreferencesUtil.shouldPreferenceNeedReview(
                  profileVisibilityReviewedAt
                )}
              >
                Profile Visibility
              </PreferencesNavigationItem>
              <PreferencesNavigationItem
                name="SIDE_NAV_PROGRAMS"
                url="../programs"
                showBadge={PreferencesUtil.shouldPreferenceNeedReview(
                  programsPreferencesReviewedAt
                )}
              >
                Programs
              </PreferencesNavigationItem>
            </>
          )}
        </Layout>
      </CardSection>
    </Card>
  );
};
